import { useQueryUpdate } from './useQueryUpdate'

export const useResetPagination = () => {
  const { params, updateQuery } = useQueryUpdate()

  const resetPagination = () => {
    if (params.page && params.page !== 1) updateQuery({ page: 1 })
  }

  return { resetPagination }
}
